export default {"src":"/_next/static/media/close-icon.5d84a518.svg","height":24,"width":24};